import React from 'react';
import './Finance.css';
import MortgageCalculator from 'mortgage-calculator-react';

function Finance() {
	return (
		<div className='finance-page'>
			<h2 id='client-title'>Finances</h2>
			<div className='mortgage-calc'>
				<MortgageCalculator />
			</div>
		</div>
	);
}

export default Finance;
